export const gradientsPopular = [
  {
    gradient_colors:
      "linear-gradient(90deg, rgb(250, 209, 6) 0%, rgb(250, 54, 11) 46%, rgb(0, 212, 255) 100%)",
    name: "Santa Cruisin'",
    id: "8r48w7",
  },
  {
    gradient_colors:
      "linear-gradient(90deg, rgba(255,97,210,1) 0%, rgba(255,204,75,1) 38%, RGBA(255,204,75,1) 62%, rgba(0,212,255,1) 100%)",
    name: "Sure, Bert!",
    id: "odpg73",
  },
  {
    gradient_colors:
      "linear-gradient(90deg, rgba(255,78,80,1) 0%, rgba(252,145,58,1) 26%, rgba(249,212,35,1) 50%, RGBA(237,229,116,1) 74%, rgba(225,245,196,1) 100%)",
    name: "Leaf Peeper",
    id: "m3kwxt",
  },
  {
    id: "0bb2iy",
    name: "Sailors' Warning",
    gradient_colors:
      "linear-gradient(90deg, rgba(0,160,176,1) 5%, RGBA(204,51,63,1) 31%, rgba(235,104,65,1) 66%, rgba(237,201,81,1) 100%)",
  },
  {
    id: "53o9y4",
    name: "Miro is 🔥",
    gradient_colors:
      "linear-gradient(90deg, rgba(255,208,47,1) 0%, rgba(255,191,191,1) 24%, rgba(255,101,117,1) 49%, RGBA(63,83,217,1) 71%, rgba(5,0,56,1) 100%)"
  },
  {
    id: "ov5o1p",
    name: "Robin's Egg",
    gradient_colors:
      "linear-gradient(90deg, rgba(7,245,194,1) 0%, RGBA(50, 129, 251, 1) 100%)",
  },
  {
    id: "cmno5y",
    name: "Cotton Candy",
    gradient_colors:
      "linear-gradient(90deg, rgba(18,194,233,1) 0%, RGBA(196,113,237,1) 46%, rgba(246,79,89,1) 100%)",
  },
  {
    id: "al8jwe",
    name: "Blood Orange",
    gradient_colors:
      "linear-gradient(90deg, rgba(248,149,12,1) 0%, RGBA(227, 10, 62, 1) 100%)",
  },
  {
    id: "yot7eq",
    name: "Pineapple Expression",
    gradient_colors:
      "linear-gradient(90deg, RGBA(254, 246, 60, 1) 8%, rgba(114,254,105,1) 50%, rgba(110,230,254,1) 87%)",
  },
  {
    id: "olccto",
    name: "Chocolate Lover",
    gradient_colors:
      "linear-gradient(90deg, rgba(30,19,12,1) 0%, RGBA(154, 132, 120, 1) 100%)",
  },
];
